/**
 * Configuration for the Suggestions API
 */

export default {
	id: 'suggestion',
	name: 'Suggestion',
	version: 'v1',
	resultsTitle: 'Suggestions',
	fields: [
		{
			name: 'Content Id',
			placeholder: 'Enter ID for source document E.g. tardisnyc/realsimple_343433',
			required: true,
			value: '',
			id: 'contentId',
			type: 'text',
		},
		{
			name: 'Show CAM Payload',
			placeholder: '',
			required: false,
			value: false,
			id: 'showCamPayload',
			type: 'bool',
		},
		{
			name: 'Or',
			required: false,
			value: '',
			id: 0,
			type: 'separator',
		},
		{
			name: 'Title',
			placeholder: 'Enter page title...',
			required: true,
			value: '',
			id: 'title',
			type: 'text',
		},
		{
			name: 'Description',
			placeholder: 'Enter text here...',
			required: true,
			value: '',
			id: 'description',
			type: 'text',
		},
		{
			name: 'Keywords',
			placeholder: 'Enter any keyword values (editor Tags, NLP, categories, taxonomy)',
			required: true,
			value: null,
			id: 'keywords',
			type: 'csv',
		},
	],
};
